import React from 'react';
import Link from 'next/link';

interface EmptyStateCardProps {
  icon?: React.ReactNode;
  header?: string;
  message?: string;
  actionLabel?: string;
  actionHref?: string;
  actionIcon?: React.ReactNode;
}

const EmptyStateCard: React.FC<EmptyStateCardProps> = ({
  icon,
  header,
  message,
  actionLabel,
  actionHref,
  actionIcon,
}) => (
  <div className="tw:flex tw:flex-col tw:py-8 tw:md:py-14 tw:bg-white tw:items-center tw:justify-center tw:border tw:border-gray-200 tw:rounded-lg">
    <div className="tw:flex tw:flex-col tw:items-center tw:justify-center tw:px-4 tw:w-full tw:md:w-1/2">
      {icon && (
        <div className="tw:flex tw:items-center tw:justify-center tw:rounded-full tw:bg-red-100 tw:w-12 tw:h-12 tw:mb-3 tw:md:w-16 tw:md:h-16 tw:md:mb-4">
          {icon}
        </div>
      )}
      {header && (
        <h5 className="tw:text-base tw:md:text-lg tw:font-medium tw:mb-4">
          {header}
        </h5>
      )}
      {message && (
        <p className="tw:text-md tw:font-normal tw:text-gray-500 tw:mb-4 tw:text-center tw:px-4">
          {message}
        </p>
      )}
      {actionHref && (
        <Link
          href={actionHref}
          className="tw:group tw:text-md tw:font-medium tw:border tw:border-primary tw:rounded-lg tw:px-4 tw:py-2 tw:bg-primary tw:text-white tw:hover:bg-white tw:hover:text-primary tw:transition-colors tw:no-underline tw:flex tw:items-center tw:justify-center"
        >
          {actionIcon}
          {actionLabel || 'Book a space'}
        </Link>
      )}
    </div>
  </div>
);

export default EmptyStateCard;
